export default __webpack_public_path__ + "assets/models/44c9c1e77077d37b23a38e90908c76cd.glb";